module.exports = __webpack_public_path__ + "img/member_search.d761ca41.svg";